import {
  Checkbox,
  createStyles,
  makeStyles,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Theme,
} from '@material-ui/core'
import cslx from 'classnames'
import { isEqual } from 'lodash'
import { MoneyPerQuantityString } from 'model/MoneyPerQuantity'
import { QuantityString } from 'model/Quantity'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { PriceSummaryCostPriceDto } from 'services/APIs/InternalAPI/internal-api.contracts'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    selected: {
      backgroundColor: theme.palette.action.selected,
    },
    lastColumn: {
      borderBottom: 0,
    },
    rightAlign: {
      textAlign: 'right',
    },
  })
)

export function ScaledCostPriceTable(props: {
  scaledPrices: Array<PriceSummaryCostPriceDto>
  hideSelectedColumn?: boolean
  hideHeader?: boolean
  hideQuantityColumn?: boolean
}) {
  const { t } = useTranslation()
  const classes = useStyles()

  return (
    <Table size="small">
      {!props.hideHeader ? (
        <TableHead>
          <TableRow>
            <TableCell>{t('common:quantity')}</TableCell>
            <TableCell>{t('common:rate')}</TableCell>
            {!props.hideSelectedColumn && (
              <TableCell>{t('common:selected')}</TableCell>
            )}
          </TableRow>
        </TableHead>
      ) : null}
      <TableBody>
        {props.scaledPrices?.map((x, index) => (
          <TableRow
            key={index}
            className={cslx({
              [classes.selected]: x.selected,
            })}
          >
            {!props.hideQuantityColumn ? (
              <TableCell
                className={cslx({
                  [classes.lastColumn]: index === props.scaledPrices.length - 1,
                })}
              >
                {`>= ${QuantityString(x.quantity)}`}
              </TableCell>
            ) : null}
            <TableCell
              className={cslx({
                [classes.lastColumn]: index === props.scaledPrices.length - 1,
                [classes.rightAlign]: props.hideSelectedColumn,
              })}
            >
              {MoneyPerQuantityString(x.price)}
            </TableCell>
            {!props.hideSelectedColumn && (
              <TableCell
                className={cslx({
                  [classes.lastColumn]: index === props.scaledPrices.length - 1,
                })}
              >
                <Checkbox
                  checked={x.selected}
                  color="primary"
                  size="small"
                  disabled
                />
              </TableCell>
            )}
          </TableRow>
        ))}
      </TableBody>
    </Table>
  )
}

export default React.memo(ScaledCostPriceTable, isEqual)
